export default "__VITE_ASSET__93819e83__"